import {type StepProps, Steps, type StepsProps} from 'antd'
import React, {useEffect, useState} from 'react'
import StepCheckLined from './components/StepCheckLined'
import StepErrorLined from './components/StepErrorLined'

const StepsComp = (props: StepsProps) => {
  const [stepList, setStepList] = useState<StepProps[]>([])
  const [current, setCurrent] = useState<number | undefined>(props.current ?? 0)
  useEffect(() => {
    mixinStepList()
  }, [props.items, current, props.status])
  useEffect(() => {
    if (props.current || props.current === 0) {
      setCurrent(props.current)
    }
  }, [props.current])
  const mixinStepList = () => {
    const tempList: StepProps[] = []
    if (props.items && props.items.length > 0) {
      props.items.forEach((item: StepProps, index: number) => {
        if (item.status === 'error' || (props.status === 'error' && current === index)) {
          tempList.push({
            ...item,
            icon: <StepErrorLined />,
          })
        } else if (item.status === 'finish' || (props.status === 'finish' && current === index)) {
          tempList.push({
            ...item,
            icon: <StepCheckLined />,
          })
        } else if (item.status === 'wait' || (props.status === 'wait' && current === index)) {
          tempList.push({
            ...item,
          })
        } else if (props.current && index < props.current) {
          tempList.push({
            ...item,
            icon: <StepCheckLined />,
          })
        } else {
          tempList.push({
            ...item,
          })
        }
      })
    }
    setStepList([...tempList])
  }
  return <Steps {...props} items={stepList} />
}
export default StepsComp
